import React from 'react';
import {CARD_TYPE_CNAME} from '../../common/constants';
import ElidedText from '../ElidedText';
import './ListingsCount.less';

const CNAME = `${CARD_TYPE_CNAME}__listingsCount`;

const ListingsCount = ({children}) => (
    <ElidedText className={CNAME}>{children}</ElidedText>
);

export default ListingsCount;
